import React, { FC } from 'react';
import { Box } from '@mui/material';
import Logo from 'src/assets/images/Logo.png';
import { StyledEmptyStateImage } from '../StyledComponents/StyledEmptyState';

interface OrderHeaderProps {
  smScreen?: boolean;
}

const Header: FC<OrderHeaderProps> = ({ smScreen = false }) => {
  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="flex-start"
      width="100%"
      maxWidth={1200}
      px={{ xs: 1, sm: 2, md: 3 }}
      py={{ xs: 0.5, sm: 1 }}
      mt={{ xs: 0.5, sm: 1 }}
    >
      <Box display="flex" alignItems="center">
        <StyledEmptyStateImage
          src={Logo}
          width={smScreen ? '120px' : '150px'}
          height="auto"
        />
      </Box>
    </Box>
  );
};

export default Header;
